const jobSearchFormPresubmit = (e, replacements = {}) => {
    const getJobTitleSlug = (txt) => {
        txt = txt.toLowerCase();

        for(const [key, value] of Object.entries(replacements || {}))
            txt = txt.replace(String(key).toLowerCase(), value)

        return txt
            .trim()
            .replace(/ß/g, "ss")
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .replace(/\s+/g, '-')
            .replace(/[^\w-]+/g, "");
    }

    const searchLoc = e.target['location-needle'].value,
        location = e.target.location.value;

    if(searchLoc && !location) {
        const savedSuggestion = sessionStorage.getItem("jobSearchSuggestion");
        if(savedSuggestion) {
            const [id, city] = savedSuggestion.split(':');
            if(city.toLowerCase().includes(searchLoc.toLowerCase())) {
                e.target['location'].value = city;
                e.target['location-id'].value = id;
            }
        }
    }

    e.target['location-needle'].setAttribute('disabled', 'disabled');

    let action = e.target.action,
        uri = '';

    if(e.target['job-title'].value)
        uri += getJobTitleSlug(e.target['job-title'].value.trim()) + '-jobs';

    if(e.target['location'].value) {
        if(!uri) uri += 'jobs';

        uri += '-in-' + getJobTitleSlug(e.target['location'].value.trim());
    }

    if(uri)
        e.target.action = action.replace(/\/$/, "") + '/' + uri;

    ['job-title', 'location', 'location-needle'].forEach(name => e.target[name].setAttribute('disabled', 'disabled'));

    if(!e.target['location-id'].value) {
        e.target['location-id'].setAttribute('disabled', 'disabled');
        e.target['distance'].setAttribute('disabled', 'disabled');
    }

    return true;
}

export default jobSearchFormPresubmit;

